import { createSelector } from "@reduxjs/toolkit";

const selectDashboardEventsInput = (_, dashboardData) =>
  Array.isArray(dashboardData?.events) ? dashboardData.events : [];

const selectActiveEventTypeIdInput = (_, __, activeEventTypeId) =>
  activeEventTypeId;

export const selectDashboardEventsByType = createSelector(
  [selectDashboardEventsInput, selectActiveEventTypeIdInput],
  (events, activeEventTypeId) => {
    const normalizedActiveEventTypeId = Number(activeEventTypeId);

    if (Number.isNaN(normalizedActiveEventTypeId)) {
      return [];
    }

    // Create grouped map using Map
    const eventsMap = new Map();

    events.forEach((event) => {
      const key = event?.inPlay ? 0 : Number(event?.eventTypeId);

      if (!eventsMap.has(key)) {
        eventsMap.set(key, []);
      }

      eventsMap.get(key).push(event);

      // Also keep original eventTypeId grouping
      if (event?.inPlay && Number(event?.eventTypeId) !== 0) {
        const originalKey = Number(event?.eventTypeId);

        if (!eventsMap.has(originalKey)) {
          eventsMap.set(originalKey, []);
        }

        eventsMap.get(originalKey).push(event);
      }
    });

    return eventsMap.get(normalizedActiveEventTypeId) || [];
  },
);

// import { createSelector } from "@reduxjs/toolkit";

// const selectDashboardEventsInput = (_, dashboardData) =>
//   Array.isArray(dashboardData?.events) ? dashboardData.events : [];
// const selectActiveEventTypeIdInput = (_, __, activeEventTypeId) =>
//   activeEventTypeId;

// export const selectDashboardEventsByType = createSelector(
//   [selectDashboardEventsInput, selectActiveEventTypeIdInput],
//   (events, activeEventTypeId) => {
//     const normalizedActiveEventTypeId = Number(activeEventTypeId);

//     if (Number.isNaN(normalizedActiveEventTypeId)) {
//       return [];
//     }

//     if (normalizedActiveEventTypeId === 0) {
//       return events.filter(
//         (item) =>
//           item?.inPlay === true
//       );
//     }

//     return events.filter(
//       (item) => Number(item?.eventTypeId) === normalizedActiveEventTypeId,
//     );
//   },
// );
